import React from "react";
import {Axios} from "axios";

// Global context, as user is automatically 'logged in', no need to load for user
const AxiosContext = React.createContext<Axios | undefined>(undefined);

export default AxiosContext;
